var map = {
	"./Alimenticia.jpg": 71,
	"./Automotriz.jpg": 72,
	"./Avicola.jpg": 73,
	"./Ecologica.jpg": 74,
	"./Hogar.jpg": 75,
	"./Industrial-2.jpg": 76,
	"./Industrial-3.jpg": 77,
	"./Institucional-2.jpg": 78,
	"./Lecheria.jpg": 79,
	"./Piscina-2.jpg": 80,
	"./Veterinaria.jpg": 81
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;